import { createRouter, createWebHashHistory } from 'vue-router'

const routes = [
  {
    path: '/',
    name: 'home',
    component: () => import(/* webpackChunkName: "about" */ '../views/HomePage.vue')
  },
  {
    path: '/formulariomotorista',
    name: 'formulariomotorista',
    component: () => import(/* webpackChunkName: "about" */ '../views/FormularioCadastro.vue')
  },
  {
    path: '/formulariescritorio', 
    name: 'formulariescritorio',
    component: () => import(/* webpackChunkName: "about" */ '../views/FormularioEscritorio.vue')
  },
  {
    path: '/envioComSucesso',
    name: 'envioComSucesso',
    component: () => import(/* webpackChunkName: "about" */ '../views/EnvioComSucesso.vue')
  },
  {
    path: '/ErroAoEnvio',
    name: 'ErroAoEnvio',
    component: () => import(/* webpackChunkName: "about" */ '../views/ErroAoEnvio.vue')
  },
  {
    path: '/TermoDeUso',
    name: 'TermoDeUso',
    component: () => import(/* webpackChunkName: "about" */ '../views/TermoDeUso.vue')
  },
  {
    path: '/:pathMatch(.*)*',
    name: 'notFound',
    component: () => import(/* webpackChunkName: "about" */ '../views/NotFound.vue')
  },
]

const router = createRouter({
  history: createWebHashHistory(),
  routes
})

router.beforeEach((to, from, next) => {
  // rolar para o topo da página ao iniciar uma nova navegação
  window.scrollTo(0, 0)
  next()
})

export default router

